import { render, staticRenderFns } from "./SimilarTitlesGraphql.vue?vue&type=template&id=c2356b44&scoped=true&"
import script from "./SimilarTitlesGraphql.vue?vue&type=script&lang=ts&"
export * from "./SimilarTitlesGraphql.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarTitlesGraphql.vue?vue&type=style&index=0&id=c2356b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2356b44",
  null
  
)

export default component.exports